<template>
  <div class="snapppay-box" role="alert">
    <picture class="box">
      <source
        media="(max-width:648px)"
        srcset="@/assets/images/SnappPay65.png"
      />
      <img src="@/assets/images/SnappPay70.png" />
    </picture>

    <p class="description-snapPay">
      <span
        class="fontsize-small title fa-number font-weight-bold my-2"
        v-if="prices.discount_price"
      >
        {{
          `هر قسط با اسنپ پی: ${(
            Number(prices.final_price) / 4
          ).toLocaleString()} تومان`
        }}
      </span>
      <span class="fontsize-small title fa-number font-weight-bold my-2" v-else>
        {{
          `هر قسط با اسنپ پی: ${(
            Number(prices.price) / 4
          ).toLocaleString()} تومان`
        }}
      </span>

      <span class="fontsize-small fa-number description my-2">
        4 قسط ماهانه، بدون سود، چک و ضامن
      </span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    prices: Object,
  },
};
</script>
<style scoped>
.snapppay-box {
  gap: 16px;
  /*background-color: #ebecf2;*/
  background-color: #f5f5f5;
  padding-inline: 16px;
  width: fit-content;
  border-radius: 16px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.box {
  display: flex;
  margin: 0;
}

/* .snapppay-box.snapppay-box-mobile {
  display: none;
  position: fixed;
  border-top: solid 1px #7a777761;
  bottom: 85px;
  left: 0;
  right: 0;
  z-index: 100;
} */

.snapppay-box img {
  width: 50px;
  height: 50px;
  border-radius: 18px;
}

.description-snapPay {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0;
}

.description-snapPay .title {
  color: #1a1c23;
  font-size: 16px !important;
}

.description-snapPay .description {
  color: #616475;
  font-size: 14px !important;
}

.description-snapPay span {
  margin: 0 !important;
  font-size: 14px;
  text-align: right;
}

@media screen and (max-width: 999px) {
  .snapppay-box.snapppay-box-des {
    /* display: none !important; */
  }

  /* .snapppay-box.snapppay-box-mobile {
    display: flex !important;
  } */
}

/* @media screen and (max-width: 768px) {
  .snapppay-box.snapppay-box-mobile {
    display: flex !important;
  }
} */

@media screen and (max-width: 648px) {
  .description-snapPay {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0;
  }

  .description-snapPay span {
    margin: 0 !important;
    font-size: 14px;
  }

  .snapppay-box img {
    width: 40px;
    height: 40px;
  }

  .description-snapPay .title {
    color: #1a1c23;
    font-size: 14px !important;
  }

  .description-snapPay .description {
    color: #616475;
    font-size: 12px !important;
  }

  .snapppay-box {
    width: 100%;
  }
}
</style>
